import { Component } from '@angular/core';
import { Plans } from '../../shared/constants/plan.constants';
import { packageBenefitProgress } from '../../shared/constants/package-benefits';

@Component({
  selector: 'app-about-us',
  standalone: false,
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent {
  readonly benefitProgress = packageBenefitProgress;
  readonly plans = Plans;
  openWhatsApp(phoneNumber: string) {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  }
}
